import React from "react";
import {PopoverItem, ToastContext} from "@enter/core";
import * as S from "./approve-action-button.styles";
import {mdiChevronDown} from "@mdi/js";
import copy from "copy-text-to-clipboard";


export interface IApproveActionButtonProps {
    className?: string;
    id: string;
    actions?: { label: string; onClick: (id: string) => Promise<void> | void }[];
}


export class ApproveActionButton extends React.Component<IApproveActionButtonProps> {
    public static contextType = ToastContext;
    public render(): React.ReactElement {
        return (
            <div onClick={this.stopPropagation}>
                <S.StyledPopover align="right" renderButton={this.renderButton}>
                    {this.props.actions?.map((action, i) => {
                        const handleAction = () => action.onClick(this.props.id);

                        return (
                            <PopoverItem onClick={handleAction} key={i}>
                                {action.label}
                            </PopoverItem>
                        );
                    })}
                </S.StyledPopover>
            </div>
        );
    }

    private readonly stopPropagation = (e: React.MouseEvent): void => {
        e.stopPropagation();
    };

    private readonly renderButton = (): React.ReactElement => {
        return (
            <S.ActionButton className={this.props.className}>
                Action
                <S.ActionButtonIcon path={mdiChevronDown} />
            </S.ActionButton>
        );
    };

}
